/*
 * AN ARTIST'S PAGE, DIRECTION 4: "Cards / About the artist" (Daniel, 11 Oct: "I want direction 4 from design for the
 * artists' pages"). Claude Design's Artist Page Options, option 4: a small portrait, the name and the blurb, then a
 * two-way switch, "Cards · N" (open by default) or "About the artist" (the portrait with its caption and licence, the
 * life, the originals). Brief 18 and the design files: the venture repo's
 * projects/pop-cards/design-brief/claude-design/18-artist-page.md and reference/artist-page/claude-design/.
 *
 * A SELF-CONTAINED COMPONENT: this file, assets/pp-artist-page.css, and the markup below. It knows nothing of the
 * ?view= router or the Artist Pool. Today assets/rd-artists.js maps a record to `data` and calls html(); when artist
 * pages become real pages (Shopify metaobject pages), Liquid can write the same markup on the server and this file's
 * enhance() wires it, unchanged. The markup contract:
 *   [data-pp-artist]                       the root
 *     [role=tablist] > [role=tab][aria-controls]   two tabs; the panel ids are "cards" and "about"
 *     [role=tabpanel]#cards, [role=tabpanel]#about  BOTH IN THE DOM FROM THE FIRST RENDER, the closed one `hidden`
 *
 * ⛔ SEO (Daniel, 11 Oct): the About panel's words are written into the page with the cards, never fetched or built on
 * a click, so a crawler that renders the page reads the life while the Cards tab is open. The closed panel is hidden
 * with the `hidden` attribute only.
 *
 * Opens on Cards. #about, or &tab=about, opens About, and choosing a tab writes #about (or clears it), so the address
 * can be shared. An artist with no cards yet opens on About. Keyboard: the arrow keys, Home and End move between the
 * tabs and open the one they reach (the WAI-ARIA tabs pattern, automatic activation).
 */
(function () {
  'use strict';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Which tab the address asks for: 'about', 'cards', or '' (none named). */
  function asked() {
    const h = (location.hash || '').slice(1).toLowerCase();
    if (h === 'about' || h === 'life') return 'about';
    if (h === 'cards') return 'cards';
    const t = new URLSearchParams(location.search).get('tab');
    return t === 'about' || t === 'cards' ? t : '';
  }

  /*
   * data: {
   *   name, ja, role, blurb, years, born,
   *   portrait: { src, alt, caption, license, source, work }   src '' = "picture to come"; work = a sample of their
   *                                                            work, not a face (shown whole in the circle, not zoomed)
   *   life: [paragraph, …], lifeNote: html (shown when there is no life),
   *   count, cardsHtml: '<li>…</li>…' (the site's own tiles), cardsEmpty: html,
   *   originals: [{ label, url }], prev: { name, href }, next: { name, href },
   *   crumbHref, note: html (preview notes, under the blurb)
   * }
   */
  function html(d) {
    const pt = d.portrait || {};
    const want = asked() || (d.count ? 'cards' : 'about');
    const on = (k) => want === k;
    const tab = (k, label) => '<button type="button" role="tab" id="ppa-tab-' + k + '" aria-controls="' + k + '" aria-selected="' + on(k) + '" tabindex="' + (on(k) ? 0 : -1) + '">' + label + '</button>';
    const ja = d.ja ? '<p class="ppa-ja" lang="ja">' + esc(d.ja) + '</p>' : '';
    const avatar = '<div class="ppa-av' + (pt.src ? (pt.work ? ' is-work' : '') : ' is-none') + '">' +
      (pt.src ? '<img src="' + esc(pt.src) + '" alt="" loading="eager" decoding="async">' : '<span>Picture<br>to come</span>') + '</div>';
    const figure = '<figure class="ppa-fig"><div class="ppa-fig__img' + (pt.src ? '' : ' is-none') + '">' +
      (pt.src ? '<img src="' + esc(pt.src) + '" alt="' + esc(pt.alt || 'Portrait of ' + d.name) + '" loading="lazy" decoding="async">' : '<span role="img" aria-label="' + esc('Portrait of ' + d.name + ', picture to come') + '">Picture to come</span>') + '</div>' +
      (pt.caption || pt.license ? '<figcaption>' + esc(pt.caption || '') + (pt.license ? (pt.caption ? ' · ' : '') + (pt.source ? '<a href="' + esc(pt.source) + '" rel="noopener" target="_blank">' + esc(pt.license) + '</a>' : esc(pt.license)) : '') + '</figcaption>' : '') + '</figure>';
    const when = (d.years || d.born) ? '<p class="ppa-years">' + (d.years ? '<span>' + esc(d.years) + '</span>' : '') + (d.born ? '<span>Born ' + esc(d.born) + '</span>' : '') + '</p>' : '';
    const life = (d.life || []).length ? d.life.map((t) => '<p>' + esc(t) + '</p>').join('') : (d.lifeNote || '');
    return '<article class="ppa" data-pp-artist>' +
      '<nav aria-label="Breadcrumb"><ol class="ppa-crumb"><li><a href="' + esc(d.crumbHref || '#') + '">Artists</a></li><li aria-hidden="true">›</li><li aria-current="page">' + esc(d.name) + '</li></ol></nav>' +
      '<header class="ppa-head">' + avatar +
        '<div class="ppa-id"><p class="ppa-role">' + esc(d.role || 'Artist') + '</p><h1 class="ppa-name">' + esc(d.name) + '</h1>' + ja + '</div>' +
        (d.blurb ? '<p class="ppa-blurb">' + esc(d.blurb) + '</p>' : '') + (d.note || '') +
      '</header>' +
      '<div class="ppa-tabs" role="tablist" aria-label="' + esc(d.name) + '">' +
        tab('cards', 'Cards <span class="ppa-tabs__n">· ' + d.count + '</span>') + tab('about', 'About the artist') + '</div>' +
      '<section class="ppa-panel" role="tabpanel" id="cards" aria-labelledby="ppa-tab-cards" tabindex="0"' + (on('cards') ? '' : ' hidden') + '>' +
        '<h2 class="ppa-h2">On Picturepops cards <span class="ppa-h2__n">· ' + d.count + '</span></h2>' +
        (d.count ? '<ul class="rdf-grid is-four" aria-label="' + esc('Cards by ' + d.name) + '">' + d.cardsHtml + '</ul>' : (d.cardsEmpty || '')) +
      '</section>' +
      '<section class="ppa-panel" role="tabpanel" id="about" aria-labelledby="ppa-tab-about" tabindex="0"' + (on('about') ? '' : ' hidden') + '>' +
        '<div class="ppa-life">' + figure + '<div class="ppa-life__txt">' + (life ? '<h2 class="ppa-h2">The life</h2>' : '') + when + life + '</div></div>' +
        ((d.originals || []).length ? '<section class="ppa-orig" aria-labelledby="ppa-orig-h"><h2 id="ppa-orig-h" class="ppa-h3">Where to see the originals</h2><ul>' +
          d.originals.map((l) => '<li><a href="' + esc(l.url) + '" rel="noopener" target="_blank">' + esc(l.label || l.url) + '<span class="ic ic-ext" aria-hidden="true"></span></a></li>').join('') + '</ul></section>' : '') +
      '</section>' +
      (d.prev && d.next ? '<nav class="ppa-prevnext" aria-label="More artists"><a href="' + esc(d.prev.href) + '"><span><span class="ic ic-arrow-l" aria-hidden="true"></span>Previous artist</span><span>' + esc(d.prev.name) + '</span></a>' +
        '<a href="' + esc(d.next.href) + '"><span>Next artist<span class="ic ic-arrow-r" aria-hidden="true"></span></span><span>' + esc(d.next.name) + '</span></a></nav>' : '') +
    '</article>';
  }

  /* Wire the tabs of every [data-pp-artist] inside `scope` (the document when left out). Safe to call twice. */
  function enhance(scope) {
    (scope || document).querySelectorAll('[data-pp-artist]').forEach((root) => {
      if (root.__ppa) return;
      root.__ppa = true;
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panel = (t) => root.querySelector('#' + t.getAttribute('aria-controls'));
      function select(t, o) {
        o = o || {};
        tabs.forEach((x) => {
          const me = x === t;
          x.setAttribute('aria-selected', String(me));
          x.tabIndex = me ? 0 : -1;
          const p = panel(x);
          if (p) p.hidden = !me;
        });
        if (o.focus) t.focus();
        if (o.write) {
          const k = t.getAttribute('aria-controls'), q = new URLSearchParams(location.search);
          q.delete('tab');
          const qs = q.toString();
          history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + (k === 'about' ? '#about' : ''));
        }
      }
      tabs.forEach((t) => t.addEventListener('click', () => select(t, { write: true })));
      root.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
        const i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const k = e.key, n = tabs.length;
        const j = k === 'ArrowRight' ? (i + 1) % n : k === 'ArrowLeft' ? (i - 1 + n) % n : k === 'Home' ? 0 : k === 'End' ? n - 1 : -1;
        if (j < 0) return;
        e.preventDefault();
        select(tabs[j], { focus: true, write: true });
      });
      const byKey = (k) => tabs.find((t) => t.getAttribute('aria-controls') === k);
      const sync = () => { const k = asked(); if (k && byKey(k)) select(byKey(k)); };
      sync();
      window.addEventListener('hashchange', sync);
      /* A link on the page to #about or #life (from anywhere outside the tabs) opens About. */
      root.addEventListener('click', (e) => {
        const a = e.target.closest('a[href="#about"], a[href="#life"]');
        if (a) { e.preventDefault(); select(byKey('about'), { focus: true, write: true }); }
      });
    });
  }

  window.PPArtistPage = { html, enhance };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance()); else enhance();
})();
